<template>
  <v-container class="physical-activity-goal-setting-strength-training">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            {{ $ucfirst($t('pa.strengthTrainingExercises')) }}:
          </v-col>
          <v-col>
            <smart-icon
              icon="mdi-dumbbell"
              class="mr-1"
            />
            <smart-icon
              icon="mdi-dumbbell"
              class="mr-1"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="mr-3">
        <v-list flat class="border" style="max-height: 450px; overflow-y: auto;">
          <v-list-item-group
            v-model="selectedItem"
            color="primary"
            v-on:change="(e) => onChangeListItemGroup(e)"
          >
            <v-list-item v-for="doc in docs" v-bind:key="doc.id">
              <v-list-item-content>
                <v-list-item-title v-text="doc.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="8">
        <v-row class="border py-3 px-5" style="min-height: 300px" :style="{
            backgroundColor: singleDocument && singleDocument.recommended ? $color.coro.lightgray : $color.coro.white // Color based on recommended state.
          }">
          <v-col cols="12" v-if="singleDocument">
            <v-row>
              <v-col cols="6" class="mr-4">
                <v-row class="mb-5">
                  <h3>{{ singleDocument.document.title }}</h3>
                </v-row>
                <v-row>
                  <div class="mt-3" v-html="singleDocument.document.parts[0].text"></div>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="mb-5">
                  <v-btn
                    class="mr-1"
                    outlined
                    v-if="singleDocument.recommended"
                    @click="() => updateRecommended(false)"
                  >
                    <smart-icon
                      icon="mdi-delete-outline"
                      size="20"
                      class="mr-1"
                    />
                    {{ $ucfirst($t('pa.removeFromRecommended')) }}
                  </v-btn>
                  <v-btn
                    class="mr-1"
                    outlined
                    v-if="!singleDocument.recommended"
                    @click="() => updateRecommended(true)"
                  >
                    <smart-icon
                      icon="mdi-plus"
                      size="20"
                      class="mr-1"
                    />
                    {{ $ucfirst($t('pa.addToRecommended')) }}
                  </v-btn>
                  <v-btn
                    outlined
                    v-if="singleDocument.favoured"
                    @click="() => updateFavoured(false)"
                  >
                    <smart-icon
                      icon="mdi-star"
                      size="20"
                      class="mr-1"
                    />
                    {{ $ucfirst($t('pa.unmarkFavorite')) }}
                  </v-btn>
                  <v-btn
                    outlined
                    v-if="!singleDocument.favoured"
                    :disabled="version == '' || version == 0 || !version"
                    @click="() => updateFavoured(true)"
                  >
                    <smart-icon
                      icon="mdi-star-outline"
                      size="20"
                      class="mr-1"
                    />
                    {{ $ucfirst($t('pa.markFavorite')) }}
                  </v-btn>
                </v-row>
                <v-row v-if="singleDocument.document.parts[1]">
                  <video
                    controls
                    v-if="singleDocument.document.parts[1].video.file.webPath"
                    width="480"
                  >
                    <source
                      :src="'http://coroprevention.internal' + singleDocument.document.parts[1].video.file.webPath /* TODO UPDATE BASE_URL! */"
                      type="video/mp4"
                    >
                  </video>
                </v-row>
              </v-col>
            </v-row>

          </v-col>
          <v-col v-else>
            <span>{{ $ucfirst($t('pa.generalInfoStrengthTraining')) }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import SmartIcon from '../../../components/Parts/SmartIcon.vue';
import { mapGetters } from 'vuex';

/**
 * Component PatientOverviewPAGoalSettingStrengthTraining.vue
 *
 * @module PatientOverviewPAGoalSettingStrengthTraining
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/Patient/PA/PatientOverviewPAGoalSettingStrengthTraining.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverviewPAGoalSettingStrengthTraining",
  components: {
    SmartIcon,
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    ...mapGetters({
      version: "encounter/version",
    }),
  },
  data: function () {
    return {
      docs: null,
      selectedItem: null,
      singleDocument: null,
    };
  },
  watch: {
    patientId: function () {
      // Do something.
      this.getAllDocuments();
    },
    docs: function () {
      // Automatically get first document, select in list and show it.
      if(this.docs.length && this.selectedItem == null) {
        this.selectedItem = 0;

        this.getSingleDocument(this.docs[0].id)
      }
    }
  },
  mounted: function () {
    this.getAllDocuments();
  },
  methods: {
    getAllDocuments() {
      this.$app.apolloMobileClient
        .query({
          query: gql`
            {
              documents(
                conditions: { field: categoryKey, value: "STRENGTH_EXERCISES" }
              ) {
                id
                title
              }
            }
          `,
        })
        .then((result) => {
          console.log("DOCS", result);
          this.docs = result.data.documents;
        });
    },
    getSingleDocument(_id) {
      this.$app.apolloMobileClient
        .query({
          query: gql`
              query getSingleDocument(
                $docId: String!, $patientId: String!
              ) {
                myPatientDocuments(
                  conditions : {
                    gate : and,
                    inputs : [
                      {field: documentId, value : $docId }
                    ]
                  }
                  functions: {
                    function: patientId,
                    parameters: [$patientId]
                  }
              ) {
                recommended
                favoured
                document{
                  id
                  title
                  parts{
                    id
                    sequence
                    type
                    ... on TextPart{
                      text
                    }
                    ... on ImagePart{
                      image{
                        file{
                          id
                          hasFile
                          fileExtension
                          handlerName
                          webPath
                          mimeType
                          size
                          width
                          height
                        }
                      }
                    }
                    ... on VideoPart{
                      video{
                        file{
                          id
                          hasFile
                          fileExtension
                          handlerName
                          webPath
                          mimeType
                          size
                          width
                          height
                        }
                      }
                      poster{
                        file{
                          id
                          hasFile
                          fileExtension
                          handlerName
                          webPath
                          mimeType
                          size
                          width
                          height
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
        variables: {
          patientId: this.patientId,
          docId: _id
        },
      })
      .then(result => {
        console.log('SINGLE', result);

        this.singleDocument = result.data.myPatientDocuments[0];
      })
    },
    onChangeListItemGroup(e) {
      console.log(this.docs[e]?.id);
      if (this.docs[e]?.id) {
        // Get document.
        this.getSingleDocument(this.docs[e]?.id);
      } else {
        this.singleDocument = null;
      }
    },
    updateRecommended(bool = false) {
       this.$app.apolloMobileClient
        .mutate({
          mutation: gql`
            mutation updateMyPatientDocument(
              $patientId: Int!
              $recommended: Boolean!
              $docId: String!
            ) {
              updateMyPatientDocument(
                patientDocument: {
                  id: $docId,
                  patientId: $patientId,
                  recommended: $recommended
                }
              ) {
                recommended
                favoured
                document{
                  id
                }
              }
            }
          `,
          variables: {
            patientId: parseInt(this.patientId),
            recommended: bool,
            docId: this.singleDocument.document.id
          }
        })
        .then(result => {
          console.log('UPDATED', result);

          // Refetch.
          this.getSingleDocument(this.singleDocument.document.id);
        })
    },
    updateFavoured(bool = false) {
      this.$app.apolloMobileClient
        .mutate({
          mutation: gql`
            mutation updateMyPatientDocument(
              $patientId: Int!
              $favoured: Boolean!
              $docId: String!
            ) {
              updateMyPatientDocument(
                patientDocument: {
                  id: $docId,
                  patientId: $patientId,
                  favoured: $favoured
                }
              ) {
                recommended
                favoured
                document{
                  id
                }
              }
            }
          `,
          variables: {
            patientId: parseInt(this.patientId),
            favoured: bool,
            docId: this.singleDocument.document.id
          }
        })
        .then(result => {
          console.log('UPDATED', result);

          // Refetch.
          this.getSingleDocument(this.singleDocument.document.id);
        })
    }
  },
};
</script>

<style lang="scss">

@import "../../../../../scss/colors";

.physical-activity-goal-setting-strength-training .v-item--active {
  background-color: map-get($coroColors, 'primary-transparent-500');

  .v-list-item__title {
    color: #FFF !important;
  }
}

</style>
